// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import App from './App.vue'
import BotaoConstituicaoDeEmpresa from './components/BotaoConstituicaoDeEmpresa.vue'
import ConteudoConstituicaoDeEmpresa from './components/ConteudoConstituicaoDeEmpresa.vue'
import BotaoAssessoriaContabil from './components/BotaoAssessoriaContabil.vue'
import ConteudoAssessoriaContabil from './components/ConteudoAssessoriaContabil.vue'

import locale from 'element-ui/lib/locale/lang/pt-br'

Vue.prototype.$eventBus = new Vue()

Vue.use(VueResource)
Vue.use(ElementUI, { locale })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {
    BotaoConstituicaoDeEmpresa,
    ConteudoConstituicaoDeEmpresa,
    BotaoAssessoriaContabil,
    ConteudoAssessoriaContabil
  }
  // render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js